<template>
	<transition
			name="custom-classes-transition"
			:enter-active-class="$_stgLst_styleComponentAnimation()">
		<template v-if="$_stgLst_stateComponentIsInitialized">
			<v-list	class="customVList" 
					expand
					:color="$_stgLst_styleListColor"
					:dark="$_stgLst_styleListDark"
					:dense="$_stgLst_styleListDense"
					:elevation="$_stgLst_styleListElevation"
					:flat="$_stgLst_styleListFlat"
					:light="$_stgLst_styleListLight"
					:nav="$_stgLst_styleListNav"
					:rounded="$_stgLst_styleListRounded"
					:shaped="$_stgLst_styleListShaped"
					:subheader="$_stgLst_styleListSubheader"
					:three-line="$_stgLst_styleListThreeLine"
					:tile="$_stgLst_styleListTile"
					:two-line="$_stgLst_styleListTwoLine">
				<v-list-group
						v-model="isOpened_"
						no-action>
					<template v-slot:activator>
						<v-row no-gutters>
							<v-col>
								<v-subheader>
									<span	class="caption"
											v-html="$_stgLst_langTitle" />
								</v-subheader>
							</v-col>
						</v-row>
					</template>
					<v-list-item 
							class="customVListItem"
							dense
							@click="$_stgLst_switchLanguage()">
						<v-list-item-icon>
							<v-icon>language</v-icon>
						</v-list-item-icon>
						<v-list-item-title>
							<span	class="caption"
									v-html="$_stgLst_langAppLanguageTitle" />
						</v-list-item-title>
					</v-list-item>
					<v-list-item 
							class="customVListItem" 
							dense
							@click="$_stgLst_switchTheme()">
						<v-list-item-icon>
							<v-icon>invert_colors</v-icon>
						</v-list-item-icon>
						<v-list-item-title>
							<span	class="caption"
									v-html="$_stgLst_langAppThemeTitle" />
						</v-list-item-title>
					</v-list-item>
				</v-list-group>
			</v-list>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'SettingList',
		data() {
			return {
				componentName_: 'settingList',

				isOpened_: true
			}
		},
		computed: {
			// state
			$_stgLst_stateAppLanguage() {
				const self_ = this;
				return self_.getAppState('language')
			},
			$_stgLst_stateAppTheme() {
				const self_ = this;
				return self_.getAppState('theme')
			},
			$_stgLst_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			// app languages / themes
			$_stgLst_contentsAppLanguages() {
				const self_ = this;
				const contents_ = self_.getAppContents('languages')
				return self_.getContentsSubset(contents_, 'isDummy', false)
			},
			$_stgLst_contentsAppThemes() {
				const self_ = this;
				const contents_ = self_.getAppContents('themes')
				return self_.getContentsSubset(contents_, 'isDummy', false)
			},
			// contents / inits
			$_stgLst_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_stgLst_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// lang
			$_stgLst_langTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_stgLst_inits(), 'title')
				return self_.getLangsVal(lang_)
			},
			// (app contents)
			$_stgLst_langAppLanguage() {
				const self_ = this;
				const key_ = self_.$_stgLst_stateAppLanguage;
				const contents_ = self_.$_stgLst_contentsAppLanguages;
				return contents_[key_]
			},
			$_stgLst_langAppLanguageTitle() {
				const self_ = this;
				const contentVals_ = self_.$_stgLst_langAppLanguage;
				return self_.getLangsVal(contentVals_.title)
			},
			$_stgLst_langAppTheme() {
				const self_ = this;
				const key_ = self_.$_stgLst_stateAppTheme;
				const contents_ = self_.$_stgLst_contentsAppThemes;
				return contents_[key_]
			},
			$_stgLst_langAppThemeTitle() {
				const self_ = this;
				const contentVals_ = self_.$_stgLst_langAppTheme;
				return self_.getLangsVal(contentVals_.title)
			},
			// style
			$_stgLst_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_stgLst_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_stgLst_inits(), 'component')
				}
			},
			$_stgLst_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_stgLst_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_stgLst_styleList() {
				const self_ = this;
				if(self_.isEmpty(self_.$_stgLst_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_stgLst_inits(), 'list')
			},
			$_stgLst_styleListColor() {
				const self_ = this;
				const list_ = self_.$_stgLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.color)
			},
			$_stgLst_styleListDark() {
				const self_ = this;
				const list_ = self_.$_stgLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.dark)
			},
			$_stgLst_styleListDense() {
				const self_ = this;
				const list_ = self_.$_stgLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.dense)
			},
			$_stgLst_styleListElevation() {
				const self_ = this;
				const list_ = self_.$_stgLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.elevation)
			},
			$_stgLst_styleListFlat() {
				const self_ = this;
				const list_ = self_.$_stgLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.flat)
			},
			$_stgLst_styleListLight() {
				const self_ = this;
				const list_ = self_.$_stgLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.light)
			},
			$_stgLst_styleListNav() {
				const self_ = this;
				const list_ = self_.$_stgLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.nav)
			},
			$_stgLst_styleListRounded() {
				const self_ = this;
				const list_ = self_.$_stgLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.rounded)
			},
			$_stgLst_styleListShaped() {
				const self_ = this;
				const list_ = self_.$_stgLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.shaped)
			},
			$_stgLst_styleListSubheader() {
				const self_ = this;
				const list_ = self_.$_stgLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.subheader)
			},
			$_stgLst_styleListThreeLine() {
				const self_ = this;
				const list_ = self_.$_stgLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.threeLine)
			},
			$_stgLst_styleListTile() {
				const self_ = this;
				const list_ = self_.$_stgLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.tile)
			},
			$_stgLst_styleListTwoLine() {
				const self_ = this;
				const list_ = self_.$_stgLst_styleList;
				if(self_.isFalse(list_)) { return null }
				return self_.getStylesVal(list_.twoLine)
			}
		},
		methods: {
			$_stgLst_switchLanguage() {
				const self_ = this;

				const languages_ = self_.sortObject(self_.$_stgLst_contentsAppLanguages, 'order')
				const languagesArray_ = self_.arrayObject(languages_)
				const language_ = self_.getAppState('language')

				const next_ = self_.$_stgLst_getNext(languagesArray_, language_)
				
				self_.switchLanguage(next_.key)
			},
			$_stgLst_switchTheme() {
				const self_ = this;
			
				const themes_ = self_.sortObject(self_.$_stgLst_contentsAppThemes, 'order')
				const themesArray_ = self_.arrayObject(themes_)
				const theme_ = self_.getAppState('theme')

				const next_ = self_.$_stgLst_getNext(themesArray_, theme_)

				self_.switchTheme(next_.key)
			},
			$_stgLst_getNext(array, code) {
				const self_ = this;

				let first_ = {}
				
				let isFirst_ = true;
				let isNext_ = false;

				let result_ = {}

				array.forEach(item => {
					if(isFirst_){
						first_ = item;
						isFirst_ = false;
					}
					if(isNext_) {
						result_ = item;
						isNext_ = false;
					} else {
						if(item.key == code) { isNext_ = true }
					}						
				})
				if(self_.isEmpty(result_)) { result_ =  first_ }

				return result_
			}
		}
	}
</script>

<style scoped>
</style>